var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-box"},[_c('img',{staticClass:"img-list",attrs:{"src":_vm.image}}),_c('img',{staticClass:"delete",attrs:{"src":require("@/assets/svg/icon_img_delete.svg")},on:{"click":function($event){return _vm.$emit('deleteImage', _vm.index)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }